/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_Format_OptionsInputs */

const en_auto_format_options = /** @type {(inputs: Auto_Format_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open auto format options`)
};

const fr_auto_format_options = /** @type {(inputs: Auto_Format_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir les options de format automatique`)
};

const de_auto_format_options = /** @type {(inputs: Auto_Format_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Formatierungsoptionen öffnen`)
};

const it_auto_format_options = /** @type {(inputs: Auto_Format_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri le opzioni di formattazione automatica`)
};

const ru_auto_format_options = /** @type {(inputs: Auto_Format_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыть параметры автоформатирования`)
};

const es_auto_format_options = /** @type {(inputs: Auto_Format_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir las opciones de formato automático`)
};

const zh_cn2_auto_format_options = /** @type {(inputs: Auto_Format_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开自动格式化选项`)
};

const ja_auto_format_options = /** @type {(inputs: Auto_Format_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動フォーマットオプションを開く`)
};

const hi_auto_format_options = /** @type {(inputs: Auto_Format_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑटो फॉर्मेट विकल्प खोलें`)
};

const pt_pt2_auto_format_options = /** @type {(inputs: Auto_Format_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abra as opções de formatação automática.`)
};

/**
* | output |
* | --- |
* | "Open auto format options" |
*
* @param {Auto_Format_OptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_format_options = /** @type {((inputs?: Auto_Format_OptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Format_OptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_auto_format_options(inputs)
	if (locale === "de") return de_auto_format_options(inputs)
	if (locale === "it") return it_auto_format_options(inputs)
	if (locale === "ru") return ru_auto_format_options(inputs)
	if (locale === "es") return es_auto_format_options(inputs)
	if (locale === "zh-CN") return zh_cn2_auto_format_options(inputs)
	if (locale === "ja") return ja_auto_format_options(inputs)
	if (locale === "hi") return hi_auto_format_options(inputs)
	if (locale === "pt-PT") return pt_pt2_auto_format_options(inputs)
	return en_auto_format_options(inputs)
});